import React from 'react';
import { motion } from 'framer-motion';
import { useAuth } from '@/contexts/AuthContext';

export const Home = () => {
  const { user } = useAuth();

  return (
    <section
      id="home"
      className="min-h-screen flex items-center justify-center py-24 sm:py-32 relative overflow-hidden"
      data-testid="home-section"
    >
      {/* Decorative Elements */}
      <div className="absolute top-20 right-20 w-64 h-64 border-2 border-yellow-600/30 rounded-full transform rotate-12"></div>
      <div className="absolute bottom-32 left-20 w-96 h-96 border-2 border-yellow-600/20 transform -rotate-12"></div>

      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="space-y-8 z-10"
          >
            <div className="space-y-4">
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2, duration: 0.6 }}
                className="text-2xl sm:text-3xl text-slate-400"
                style={{ fontFamily: 'IBM Plex Sans' }}
              >
                Hello I'm
              </motion.p>
              <motion.h1
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3, duration: 0.6 }}
                className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white tracking-tight"
                style={{ fontFamily: 'Outfit' }}
                data-testid="profile-name"
              >
                MELVIN NIGEL<br />FERDION
              </motion.h1>
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4, duration: 0.6 }}
                className="text-xl text-slate-300 leading-relaxed"
                style={{ fontFamily: 'IBM Plex Sans' }}
                data-testid="profile-title"
              >
                A <span className="text-emerald-500 font-semibold">QA Engineer</span> unlike any you’ve worked with before<br />
                <span className="text-xs sm:text-sm text-slate-400 block mt-2 leading-relaxed">
                  🏆 #1 for Most Bugs Found (2021) — LINE Bank by Hana Bank before App Launch<br />
                  🏆 3x #1 for Most Bugs Found (2023–2025) — PT Digital Daya Teknologi (Nobu Bank Project)
                </span>
              </motion.p>
            </div>

            {/* <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5, duration: 0.6 }}
              className="flex flex-wrap gap-4 pt-4"
            >
              <button
                onClick={() => document.getElementById('bugs').scrollIntoView({ behavior: 'smooth' })}
                className="px-8 py-3 border-2 border-yellow-600 text-yellow-600 rounded-full hover:bg-yellow-600 hover:text-black transition-all duration-300 font-medium"
                style={{ fontFamily: 'IBM Plex Sans' }}
                data-testid="get-started-button"
              >
                View Sample Bug Reports
              </button>
            </motion.div> */}

            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.6, duration: 0.6 }}
              className="flex items-center space-x-4 pt-8"
            >
              <div className="text-center">
                <div className="text-4xl font-bold text-white" style={{ fontFamily: 'Outfit' }}>5+</div>
                <div className="text-sm text-slate-400" style={{ fontFamily: 'IBM Plex Sans' }}>Years Experience</div>
              </div>
              <div className="w-px h-12 bg-white/20"></div>
              <div className="text-center">
                <div className="text-4xl font-bold text-white" style={{ fontFamily: 'Outfit' }}>500+</div>
                <div className="text-sm text-slate-400" style={{ fontFamily: 'IBM Plex Sans' }}>Bugs Found</div>
              </div>
            </motion.div>
          </motion.div>

          {/* Right Content - Image */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.4, duration: 0.8 }}
            className="relative flex justify-center lg:justify-end z-10"
          >
            <div className="relative">
              {/* Decorative border */}
              <div className="absolute inset-0 border-4 border-yellow-600 transform translate-x-8 translate-y-8 -z-10"></div>

              {/* Image container with gradient background */}
              <div className="relative w-80 h-96 lg:w-96 lg:h-[500px] overflow-hidden border border-white/10" style={{ background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(6, 95, 70, 0.1) 100%)' }}>
                <img
                  src="https://customer-assets.emergentagent.com/job_melvin-portfolio/artifacts/1vx6nzv2_ChatGPT%20Image%20Jun%2013%2C%202026%2C%2012_53_45%20PM.png"
                  alt="Melvin Nigel Ferdion"
                  className="w-full h-full object-cover object-center"
                  data-testid="profile-avatar"
                />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
